export const dashboardTextDataHook = 'dashboard-text';
